const PERSONALIZED_WORKOUTS = 'Personalized workouts'
const PERSONALIZED_NUTRITION = 'Personalized nutrition coaching'
const BUILD_HABITS = 'Build healthy habits'
const LASTING_CHANGES = 'Make lasting changes'
const LEARN_FITNESS = 'Learn and get fit'
const LEARN_NUTRITION = 'Learn while getting healthy'
const DAILY_GUIDANCE = 'Daily guidance from your certified coach'
const DAILY_ACCOUNTABILITY = 'Daily accountability from your certified coach'
const FLEXIBILITY = 'Train when and where you want'
const SET_GOALS = 'Set goals with a certified coach'
const HABIT_TRACKING = 'Habit building and tracking'
const COPAY_FREE = '$0 out of pocket for most clients'

export const DEFAULT_VALUE_PROPS = [
  PERSONALIZED_WORKOUTS,
  DAILY_GUIDANCE,
  FLEXIBILITY,
]

export const FITNESS_VALUE_PROPS = [
  PERSONALIZED_WORKOUTS,
  DAILY_GUIDANCE,
  FLEXIBILITY,
]

export const NUTRITION_VALUE_PROPS = [
  PERSONALIZED_NUTRITION,
  DAILY_GUIDANCE,
  HABIT_TRACKING,
]

export const HABIT_VALUE_PROPS = [SET_GOALS, BUILD_HABITS, LASTING_CHANGES]

export const CATEGORY_SLUGS_TO_CATEGORIES = {
  fitness: 'fitness',
  habits: 'habits',
  nutrition: 'nutrition',
  'eat-better': 'nutrition',
  hydration: 'nutrition',
  'mental-health': 'habits',
  diets: 'nutrition',
  nutritionists: 'nutrition',
}

export const VALUE_PROPS_BY_CATEGORY = {
  fitness: FITNESS_VALUE_PROPS,
  habits: HABIT_VALUE_PROPS,
  nutrition: NUTRITION_VALUE_PROPS,
}

export const INSURANCE_VALUE_PROPS = [
  PERSONALIZED_NUTRITION,
  DAILY_GUIDANCE,
  COPAY_FREE,
]
